/** @jsx jsx **/
import { jsx, Text } from 'theme-ui'
import { FC } from 'react'

type Props = {
  label?: string
  color?: string
}

const ProductLabel: FC<Props> = ({ label = 'Sale', color }) => {
  return (
    <Text
      className={`ProductLabel--${label}`}
      sx={{
        display: 'flex',
        height: 40,
        alignItems: 'center',
        border: '1px solid',
        borderColor: 'strokes',
        bg: 'main',
        px: '18px',
        borderRadius: 20,
        pointerEvents: 'none',
        userSelect: 'none',
        color: color ?? 'muted',
        textTransform: 'uppercase',
      }}
    >
      {label}
    </Text>
  )
}

export default ProductLabel
